export default __webpack_public_path__ + "static/media/partner-3.29115f5b.png";